// extracted by mini-css-extract-plugin
export default {"root":"BreadCrumbsPageBlock_root__PTndv","separator":"BreadCrumbsPageBlock_separator__OhrpE"};